export function parseSemver(version) {
  if (typeof version !== 'string') {
    version = '' + version;
  }

  const [major, minor, patch] = version.split('.').map(Number);
  return { major, minor, patch };
}
